import { render, staticRenderFns } from "./addacaboutenoughcut.vue?vue&type=template&id=8be5a118&scoped=true&"
import script from "./addacaboutenoughcut.vue?vue&type=script&lang=js&"
export * from "./addacaboutenoughcut.vue?vue&type=script&lang=js&"
import style0 from "./addacaboutenoughcut.vue?vue&type=style&index=0&id=8be5a118&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8be5a118",
  null
  
)

export default component.exports